export const locations = {
    dekluis: {
        name: 'De Kluis',
        apiurl: 'dekluis.ddns.net'
    },
    backup: {
        name: 'Backup',
        apiurl: '192.168.0.13'
    },
    local: {
        name: 'Local',
        apiurl: window.location.hostname
    },
    localhost: {
        name: 'Localhost',
        apiurl: 'localhost'
    }
};
